"use strict";

exports.__esModule = true;
exports.default = exports.MediaSelector = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _grid = require("@jsluna/grid");

var _button = require("@jsluna/button");

var _MediaInput = _interopRequireDefault(require("./MediaInput"));

var _constants = require("../utils/constants");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var MediaSelector = function MediaSelector(_ref) {
  var onMediaUpdated = _ref.onMediaUpdated,
      title = _ref.title,
      buttonText = _ref.buttonText,
      initialMediaAttachments = _ref.initialMediaAttachments,
      maxUploads = _ref.maxUploads,
      imageOnly = _ref.imageOnly;

  var _useState = (0, _react.useState)(initialMediaAttachments),
      mediaAttachments = _useState[0],
      setMediaAttachments = _useState[1];

  var mediaSelectorInput = null;

  var setMediaSelectorInput = function setMediaSelectorInput(element) {
    mediaSelectorInput = element;
  };

  var handleSetMediaAttachments = function handleSetMediaAttachments(newMediaAttachments) {
    setMediaAttachments(newMediaAttachments);
    onMediaUpdated(newMediaAttachments);
  };

  var updateFileState = function updateFileState(file, id) {
    var reader = new FileReader();

    reader.onloadend = function () {
      var mediaObject = {
        data: reader.result,
        file: file,
        type: file.type === _constants.MIME_TYPE_PDF ? _constants.FILE_TYPE_PDF : _constants.FILE_TYPE_IMAGE
      };

      if (id !== undefined) {
        handleSetMediaAttachments(mediaAttachments.map(function (x, i) {
          return i === id ? Object.assign({}, mediaObject, {
            id: x.id
          }) : x;
        }));
      } else {
        handleSetMediaAttachments([].concat(mediaAttachments, [mediaObject]));
      }
    };

    reader.readAsDataURL(file);
  };

  var handleDataChange = function handleDataChange(e, id, replace) {
    if (replace === void 0) {
      replace = false;
    }

    if (replace || mediaAttachments.length < maxUploads) {
      var file = e.target.files[0];

      if (file !== undefined && file.size < _constants.MAX_FILE_SIZE_BYTES && !mediaAttachments.some(function (x) {
        return x.file.name === file.name;
      })) {
        switch (file.type) {
          case _constants.FILE_TYPE_IMAGE_PNG:
          case _constants.FILE_TYPE_IMAGE_JPEG:
          case _constants.FILE_TYPE_IMAGE_GIF:
            updateFileState(file, id);
            break;

          case _constants.MIME_TYPE_PDF:
            if (!imageOnly) {
              updateFileState(file, id);
            }

            break;

          default:
            break;
        }
      }
    }

    mediaSelectorInput.value = '';
  };

  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: "attachMediaLabel",
    className: "ln-c-label"
  }, title), /*#__PURE__*/_react.default.createElement("input", {
    ref: setMediaSelectorInput,
    type: "file",
    name: "file",
    onChange: function onChange(e) {
      return handleDataChange(e);
    },
    style: {
      display: 'none'
    }
  }), /*#__PURE__*/_react.default.createElement(_grid.GridWrapper, null, mediaAttachments && mediaAttachments.map(function (x, i) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: x.data
    }, /*#__PURE__*/_react.default.createElement("input", {
      id: i,
      type: "file",
      name: "file",
      onChange: function onChange(e) {
        return handleDataChange(e, i, true);
      },
      style: {
        display: 'none'
      }
    }), /*#__PURE__*/_react.default.createElement(_MediaInput.default, {
      orderId: i,
      media: x,
      remove: function remove() {
        handleSetMediaAttachments(mediaAttachments.filter(function (y) {
          return x.file.name !== y.file.name;
        }));
      },
      handleMediaReplace: function handleMediaReplace(e) {
        return document.getElementById(i).click(e);
      },
      handleDescriptionUpdated: function handleDescriptionUpdated(description) {
        handleSetMediaAttachments(mediaAttachments.map(function (y) {
          return x.file.name !== y.file.name ? y : Object.assign({}, y, {
            description: description
          });
        }));
      }
    }));
  })), /*#__PURE__*/_react.default.createElement(_grid.GridWrapper, null, /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
    size: {
      default: '1/1',
      md: '1/3'
    }
  }, /*#__PURE__*/_react.default.createElement(_button.OutlinedButton, {
    fullWidth: true,
    color: "dark",
    onClick: function onClick() {
      return mediaSelectorInput.click();
    }
  }, buttonText))));
};

exports.MediaSelector = MediaSelector;
MediaSelector.propTypes = {
  onMediaUpdated: _propTypes.default.func,
  title: _propTypes.default.string,
  buttonText: _propTypes.default.string,
  initialMediaAttachments: _propTypes.default.arrayOf(_propTypes.default.shape({
    data: _propTypes.default.string,
    id: _propTypes.default.number,
    type: _propTypes.default.string,
    description: _propTypes.default.string,
    file: _propTypes.default.object
  })),
  maxUploads: _propTypes.default.number,
  imageOnly: _propTypes.default.bool
};
MediaSelector.defaultProps = {
  onMediaUpdated: function onMediaUpdated() {},
  initialMediaAttachments: [],
  title: 'Media Upload',
  buttonText: 'Upload Media',
  maxUploads: _constants.MAX_FILE_UPLOADS,
  imageOnly: false
};
var _default = MediaSelector;
exports.default = _default;